const MULTIPLE_THRESHOLD = 1.8;

const multipleFormatter = new Intl.NumberFormat('fr-FR', {
	minimumFractionDigits: 1,
	maximumFractionDigits: 1,
});

/** "× 2,0 la moyenne" when an item costs clearly more than the reference average; `null` otherwise. */
const resolveAverageMultiple = (cost: number, referenceAverage: number | null): string | null => {
	if (referenceAverage === null || referenceAverage <= 0 || cost <= referenceAverage * MULTIPLE_THRESHOLD) {
		return null;
	}

	return `× ${multipleFormatter.format(cost / referenceAverage)} la moyenne`;
};

export default resolveAverageMultiple;
